import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Paginator } from '../../models/paginator';

@Component({
  selector: 'cw-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() paginator: Paginator<any>;
  @Input() loading: boolean;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
  }

  previous() {
    this.pageChanged.emit(this.paginator.currentPage - 1);
  }

  next() {
    this.pageChanged.emit(this.paginator.currentPage + 1);
  }

  get hasNextPage() {
    return this.paginator.currentPage < this.paginator.totalPages;
  }

  get hasPreviousPage() {
    return this.paginator.currentPage > 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination.component.ts